<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mb-3">
        <SGPFormSelectComponent
          class="input-background"
          name="ctrl_provedor_id"
          :listaDeOptions="listaDeProvedores"
          v-model="formulario.ctrl_provedor_id"
          optionLabel="nome"
          optionValue="id"
          placeholder="Provedor"
          data-vv-as="Provedor"
          v-validate="'required'"
          :error="validationErrors.first('ctrl_provedor_id')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="nome"
          v-model="formulario.nome"
          placeholder="Nome Completo"
          data-vv-as="Nome Completo"
          v-validate="'required|max:150'"
          :error="validationErrors.first('nome')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="rg"
          v-model="formulario.rg"
          placeholder="RG"
          data-vv-as="RG"
          :error="validationErrors.first('rg')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="cpf"
          v-model="formulario.cpf"
          placeholder="CPF"
          data-vv-as="CPF"
          v-validate="'required|max:20'"
          :error="validationErrors.first('cpf')"
          v-mask="['###.###.###-##']"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="telefone"
          v-model="formulario.telefone"
          placeholder="Telefone"
          data-vv-as="Telefone"
          :error="validationErrors.first('telefone')"
          v-mask="['(##) ####-####', '(##) # ####-####']"
        />
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button
              class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit"
            >
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>

            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button"
              @click="fecharModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FormularioCtrlTecnicoComponent',

  props: {
    tipoFormulario: {
      type: String,
      default: 'salvar'
    },
    ctrlTecnico: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      formulario: {}
    }
  },

  computed: {
    ...mapGetters('ctrlProvedores', ['listaDeProvedores'])
  },

  created () {
    this.listarProvedores()
  },

  methods: {
    ...mapActions('ctrlTecnicos', [
      'salvarTecnico',
      'atualizarTecnico'
    ]),

    ...mapActions('ctrlProvedores', [
      'listarProvedores'
    ]),

    async submit () {
      const valido = await this.$validator.validateAll()

      if (!valido) return

      try {
        if (this.tipoFormulario === 'salvar') {
          await this.salvarTecnico(this.formulario)
        } else {
          await this.atualizarTecnico(this.formulario)
        }

        this.$emit('atualizarListagemTabela')
        this.limparCampos()
        this.fecharModal()

      } catch (error) {
        // Tratamento visual realizado pelo interceptor Axios
      }
    },

    limparCampos () {
      this.formulario = {
        id: null,
        ctrl_provedor_id: null,
        nome: '',
        rg: '',
        cpf: '',
        telefone: ''
      }

      this.$validator.reset()
    },

    fecharModal () {
      this.$emit('fechar')
    },

    hidratarFormulario (tecnico = {}) {
      this.formulario = {
        id: tecnico.id || null,
        ctrl_provedor_id: tecnico.ctrl_provedor_id || null,
        nome: tecnico.nome || '',
        rg: tecnico.rg || '',
        cpf: tecnico.cpf || '',
        telefone: tecnico.telefone || ''
      }
    }
  },

  watch: {
    ctrlTecnico: {
      immediate: true,
      handler (novoTecnico) {
        this.hidratarFormulario(novoTecnico)
      }
    }
  }
}
</script>
